import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import {
  Box,
  Container,
  Avatar,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TableFooter,
  TablePagination,
  TextField,
  Divider,
  Alert
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UserListSkelet from '../../skeletons/UserListSkelet';
import { useDelete, useGet, usePost } from '../../API/request';
import { useConfirm } from '../../components/Confirm/index';
import { BallTriangle } from 'react-loader-spinner';
import '../../styles/All.css';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';

const CompanyEmailsList = () => {
  const { id } = useParams();
  const confirm = useConfirm();
  const getU = useGet();
  const postU = usePost();
  const deleteU = useDelete();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isLoaded, setIsLoaded] = useState(true);

  const [disableLoadTable, setDisableLoadTable] = useState(false);
  const [loadedTable, setLoadedTable] = useState('');

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);

  const [queryParams, setQueryParams] = useState({
    name: searchParams.get('name') || '',
    type: searchParams.get('type') || '',
    page: searchParams.get('page') || 0,
    limit: searchParams.get('limit') || 10
  });

  const [alert, setAlert] = useState({
    txt: '',
    isVisible: false,
    type: 'error'
  });

  const showAlert = (type, text) => {
    setAlert({
      txt: text,
      type,
      isVisible: true
    });

    setTimeout(() => {
      setAlert({
        txt: text,
        type,
        isVisible: false
      });
    }, 2500);
  };

  const XMLUpLoaded = (event) => {
    setLoadedTable(event.target.files[0]);
  };

  const onPostTale = () => {
    if (loadedTable !== '') {
      setDisableLoadTable(true);
      console.log('here');
      let data = new FormData();
      data.append('table', loadedTable);

      postU(`companies/emails/xlsx/${id}`, data)
        .then((resp) => {
          if (resp.status === 'success') {
            showAlert('success', 'Вы успешно загрузили таблицу');
            if (resp.data.errors) {
            }
            setLoadedTable('');
          } else {
            showAlert(
              'error',
              'Произошла ошибка при попытке загрузить таблицу'
            );
          }
        })
        .catch((e) => {
          showAlert('error', e.response.data.message);
        })
        .finally(() => {
          setDisableLoadTable(false);
          document.getElementById('dishXMLTable').value = null;
          loadUsers();
        });
    }
  };

  const loadUsers = () => {
    setIsLoaded(true);

    let endpoint = `companies/emails?page=${
      Number(searchParams.get('page')) + 1
    }&limit=${Number(searchParams.get('limit'))}&companyId=${id}`;

    getU(endpoint)
      .then((resp) => {
        if (resp.status === 'success') {
          setData(resp.data.emails);
          setCount(resp.data.currentCount || 0);
          // setLimit(resp.data.limit)
          // setPage(Number(resp.data.page))
        } else {
          showAlert(
            'error',
            'Произошла ошибка при получении email`ов, повторите попытку позже'
          );
        }
      })
      .catch((err) => {
        console.log(err.response);
        setData([]);
        setCount(0);
      })
      .finally(() => {
        setIsLoaded(false);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (queryParams.name !== '') {
      setSearchParams({
        name: queryParams.name,
        page: newPage,
        limit:
          Number(searchParams.get('limit')) === 0
            ? 10
            : Number(searchParams.get('limit'))
      });
    } else if (queryParams.type !== '') {
      setSearchParams({
        type: queryParams.type,
        page: newPage,
        limit:
          Number(searchParams.get('limit')) === 0
            ? 10
            : Number(searchParams.get('limit'))
      });
    } else {
      setSearchParams({
        page: newPage,
        limit:
          Number(searchParams.get('limit')) === 0
            ? 10
            : Number(searchParams.get('limit'))
      });
    }
  };

  const handleChangeLimit = (event) => {
    setLimit(event.target.value);
    setPage(0);
    if (queryParams.name !== '') {
      setSearchParams({
        name: queryParams.name,
        page: 1,
        limit: event.target.value
      });
    } else if (queryParams.type !== '') {
      setSearchParams({
        type: queryParams.type,
        page: 0,
        limit: event.target.value
      });
    } else {
      setSearchParams({
        page: 0,
        limit: event.target.value
      });
    }
  };

  useEffect(() => {
    onPostTale();
  }, [loadedTable]);

  const onDelete = (id) => {
    confirm({
      title: 'Удаление',
      content: 'Вы уверены, что хотите удалить email?',
      onConfirm: () => {
        deleteU(`companies/emails/${id}`)
          .then((resp) => {
            if (resp.status === 'success') {
              loadUsers();
            } else {
              showAlert('error', 'Произошла ошибка при попытке удалить email');
            }
          })
          .catch((e) => {
            showAlert('error', e.response.data.message);
          });
      }
    });
  };

  useEffect(() => {
    if (queryParams.name === '') {
      searchParams.delete('name');
      setSearchParams(searchParams);
    }
    if (queryParams.type === '') {
      searchParams.delete('type');
      setSearchParams(searchParams);
    }
  }, [queryParams]);

  useEffect(() => {
    loadUsers();
  }, [searchParams]);

  if (isLoaded) {
    return (
      <div className="loader">
        <BallTriangle
          height="100"
          width="100"
          color="grey"
          ariaLabel="loading"
        />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Emails</title>
      </Helmet>
      <Box className="headerWrapper">
        <Box className="headerTitle">Email`ы</Box>
      </Box>
      <Box
        sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}
      >
        <Container maxWidth={false}>
          <Alert
            severity={alert.type}
            style={{
              display: alert.isVisible ? 'flex' : 'none',
              marginBottom: 10
            }}
          >
            {alert.txt}
          </Alert>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Box sx={{ marginLeft: 2 }}>
              <Input
                type="file"
                style={{ display: 'none' }}
                id="dishXMLTable"
                disabled={disableLoadTable}
                onChange={XMLUpLoaded}
              />
              <label htmlFor="dishXMLTable">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  component="span"
                  disabled={disableLoadTable}
                >
                  Загрузить таблицу email`ов
                </Button>
              </label>
            </Box>
          </Box>
          <Box sx={{ pt: 3 }}>
            <Card>
              <PerfectScrollbar>
                <Box sx={{ minWidth: 1500 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ width: 80 }}>Id</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data?.map((item) => (
                        <TableRow hover key={item.id}>
                          <TableCell sx={{ width: 80 }}>{item?.id}</TableCell>
                          <TableCell>{item?.email || '---'}</TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex' }}>
                              <Box sx={{ display: 'flex' }}>
                                <Box sx={{ ml: 2 }}>
                                  <Button
                                    color="error"
                                    variant="contained"
                                    onClick={() => onDelete(item.id)}
                                  >
                                    Удалить
                                  </Button>
                                </Box>
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          labelRowsPerPage={
                            <span>Кол-во строк на странице:</span>
                          }
                          rowsPerPageOptions={[10, 20, 30, 40, 50]}
                          colSpan={7}
                          count={count}
                          page={Number(searchParams.get('page'))}
                          rowsPerPage={
                            Number(searchParams.get('limit')) === 0
                              ? 10
                              : Number(searchParams.get('limit'))
                          }
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeLimit}
                        />
                        {console.log(Number(searchParams.get('limit')))}
                      </TableRow>
                    </TableFooter>
                  </Table>
                </Box>
              </PerfectScrollbar>
            </Card>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CompanyEmailsList;
